<script>
  // Optionally, you can define any local variables or functionality here
</script>

<style>
  @font-face {
    font-family: 'Nimbus Sans';
    src: url('/fonts/NimbusSanL-Bol.otf') format('opentype');
    font-weight: bold;
  }

  @font-face {
    font-family: 'Nimbus Sans';
    src: url('/fonts/NimbusSanL-Reg.otf') format('opentype');
    font-weight: normal;
  }

  .terms-container {
    max-width: 800px;
    margin: 30px auto;
    padding: 10px;
    line-height: 1.6;
    font-family: 'Nimbus Sans', sans-serif; /* Applying the custom font */
    color: white;
  }

  h1 {
    text-align: left;
  }

  h1 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1.1;
  }

  h2 {
    margin-top: 30px;
    font-size: 1.3rem;
    font-weight: bold;
    text-align: left;
  }

  p {
    margin: 5px 0;
  }

  ul {
    margin: 0px;
    list-style-type: disc;
  }

  ol {
    margin: 5px;
  }

  li {
    margin: 5px 0;
  }

  .highlight-text {
    color: #ED1C24; /* Color for "TERMS" */
  }

  .highlight-accent {
    color: #FCAF17; /* Color for "CONDITIONS" */
  }
</style>

<div class="terms-container">
  <h1>
    <span class="highlight-text">TERMS</span> &amp; <span class="highlight-accent">CONDITIONS</span>
  </h1>

  <ul>
    <li>These Terms and Conditions will govern your participation in the Niterra competition. You are deemed to have read and consented to the terms and conditions and agree to be bound thereby before entering this Competition. Information regarding the Competition that is published on authorised advertising material will also form part of the terms and conditions of the Competition.</li>
    <li>The competition is organised by Niterra SA (Pty) Ltd</li>
    <li>This Competition will run from 1st of November 2024 – 31st of December 2024. Entries received after the closing date will not be considered.</li>
  </ul>

  <h2><span class="highlight-text">WHO</span> CAN <span class="highlight-accent">ENTER?</span></h2>
  <ul>
    <li>Participants must be 18 years or older (or if a minor, must be duly assisted by their legal guardians) be a South African citizen or permanent resident in the Republic of South Africa (“RSA”), and have a valid identity document or passport and reside in the RSA during the period of the Competition</li>
    <li>Participants may not enter or receive a prize if they are directors, members, partners, employees, agents of/or consultants of NGK or Midas</li>
  </ul>

  <h2><span class="highlight-text">HOW</span> TO <span class="highlight-accent">ENTER</span></h2>
  <ul>
    <li>The competition mechanics state that you need to:</li>
    <ol>
      <li>Purchase any four (4) NGK products at any Midas store.</li>
      <li>Scan the QR code in store.</li>
      <li>Enter your details (Name, Surname, cell number). Please type in your personal details correctly for entry validation purposes.</li>
      <li>Upload a picture of your invoice to validate your entry. Please take a clear picture for your entry to be valid.</li>
    </ol>
    <ul>
      <li>Only one (1) entry per four (4) NGK products (spark plugs) bought. A new invoice number will be required if you wish to enter the competition again.</li>
      <li>Winners will be contacted telephonically to verify their prize delivery address.</li>
      <li>Grand prize winners will be published on the Midas Facebook page.</li>
    </ul>
  </ul>

  <h2><span class="highlight-text">PRIZES</span></h2>
  <ul>
    <li>Prizes to be won are:</li>
    <ul>
      <li>NGK Caps</li>
      <li>NGK Lunch Bags</li>
      <li>Air Fryers</li>
      <li>Tool Kits (Grand Prize)</li>
    </ul>
    <li>Delivery of prizes will be in 3 to 5 working days from the date of winning.</li>
  </ul>

  <h2><span class="highlight-text">PUBLICITY</span> &amp; <span class="highlight-accent">DATA PRIVACY</span></h2>
  <p>All personal information relating to the Participants will be used solely in accordance with South African consumer and data protection legislation.</p>
</div>
